import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useI18n } from '../contexts/I18nContext';
import { DIVISIONS, CONTACT_EMAIL } from '../data/divisions';
import './Hero.css';

export function Hero() {
  const { t } = useI18n();

  return (
    <section className="hero">
      <div className="hero-orbs" aria-hidden="true">
        <span className="orb orb-1" />
        <span className="orb orb-2" />
        <span className="orb orb-3" />
      </div>

      <div className="hero-inner">
        <div className="hero-eyebrow reveal">
          <Sparkles size={14} />
          <span>{t('hero.eyebrow')}</span>
        </div>

        <h1 className="hero-title reveal">
          {t('hero.titleA')}{' '}
          <span className="gradient-text">{t('hero.titleB')}</span>
        </h1>

        <p className="hero-lead reveal">{t('hero.lead')}</p>

        <div className="hero-actions reveal">
          <a href="#divisions" className="btn btn-primary">
            {t('hero.ctaPrimary')}
            <ArrowRight size={18} />
          </a>
          <a href={`mailto:${CONTACT_EMAIL}`} className="btn btn-ghost">
            {t('hero.ctaSecondary')}
          </a>
        </div>

        <div className="hero-stats reveal">
          <div className="hero-stat">
            <strong>4</strong>
            <span>{t('hero.statDivisions')}</span>
          </div>
          <div className="hero-stat">
            <strong>{t('hero.statFocus')}</strong>
            <span>{t('hero.statFocusSub')}</span>
          </div>
          <div className="hero-stat">
            <strong>{t('hero.statHq')}</strong>
            <span>{t('hero.statHqSub')}</span>
          </div>
        </div>

        <div className="hero-chips reveal">
          {DIVISIONS.map((d) => {
            const Icon = d.icon;
            return (
              <Link key={d.key} to={d.path} className={`hero-chip ${d.accent}`}>
                <Icon size={15} />
                <span>{t(d.nameKey)}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
